import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TexteHtml } from '@components/texte-html/models';
import { HandleHtmlLinksDirective } from '@shared/directives';

@Component({
  selector: 'app-texte-html',
  templateUrl: './texte-html.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HandleHtmlLinksDirective],
})
export class TexteHtmlComponent extends AbstractDynamicComponent<TexteHtml> {}
